import type { Observation } from "fhir/r4";
import type { FC } from "react";
import React, { useEffect, useMemo } from "react";
import ObservationBundleBloc from "src/state/ObservationBundleBloc/ObservationBundleBloc";
import { useBloc } from "src/state/state";
import { ReferenceRangeBar as ReferenceRangeBarBase } from "@9amhealth/shared";

interface ReferenceRangeBarProps {
  observation: Observation;
}

const ReferenceRangeBar: FC<ReferenceRangeBarProps> = ({ observation }) => {
  const [
    { observationRangesData },
    { getRangeContainingObservation, getObservationRangesData }
  ] = useBloc(ObservationBundleBloc, {
    create: () => new ObservationBundleBloc(observation)
  });

  useEffect(() => {
    getObservationRangesData();
  }, []);

  const { observationValue, ranges, normalRangeMin, normalRangeMax } = useMemo(
    () => observationRangesData ?? {},
    [observationRangesData]
  );

  const activeRangeId = useMemo(
    () => getRangeContainingObservation(observation)?.id,
    []
  );

  if (!ranges?.length || typeof observationValue !== "number") {
    return null;
  }

  return (
    <ReferenceRangeBarBase
      observationValue={observationValue}
      ranges={ranges}
      normalRangeMin={normalRangeMin}
      normalRangeMax={normalRangeMax}
      activeRangeId={activeRangeId}
    />
  );
};

export default ReferenceRangeBar;
